import React, {useState, useEffect} from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { ArrowRightCircle } from 'react-bootstrap-icons'
import HeaderImg from '../assets/img/header-img.svg'
import 'animate.css'
import TrackVisibility from 'react-on-screen'


const Banner = () => {

    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Web Developer", "Web Designer", "UI/UX Designer"];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const period = 2000;

    useEffect(() => {
      let ticker = setInterval(()=>{
        tick();
      }, delta)
    
      return () => {
        clearInterval(ticker)
      }
    }, [text])
    
    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0,text.length + 1);
        setText(updatedText);

        if (isDeleting){
            setDelta(prevDelta => prevDelta /2)
        }
        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        } else if(isDeleting && updatedText === ''){
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    }

  return (
    <section className="banner" id="home">
        <Container>
            <Row className='align-items-center' >
                <Col xs={12} md={6} xl={7}>
                  <TrackVisibility>
                  {({isVisible}) => 
                  <div className={isVisible ? 'animate__animated animate__fadeIn' : ''} >
                    <span className="tagline">Welcome to my Portfolio</span>
                    <h1>{`Hi I'm webcoded `}<span className="wrap">{text}</span></h1>
                    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eaque ex recusandae accusamus vitae voluptas ea beatae expedita quisquam delectus placeat.</p>
                    <button onClick={() => window.location.href='#connect'}>Let's Connect <ArrowRightCircle size={25}/> </button>
                  </div>}
                  </TrackVisibility>
                </Col>
                <Col xs={12} md={6} xl={5}>
                    <img src={HeaderImg} alt="Header Img" />
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default Banner